namespace GeniuzPOS.Product {
    export interface CsSubCategory1Form {
        SubCat1Code: Serenity.StringEditor;
        SubCat1Name: Serenity.StringEditor;
    }

    export class CsSubCategory1Form extends Serenity.PrefixedContext {
        static formKey = 'Product.CsSubCategory1';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsSubCategory1Form.init)  {
                CsSubCategory1Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsSubCategory1Form, [
                    'SubCat1Code', w0,
                    'SubCat1Name', w0
                ]);
            }
        }
    }
}
